import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './../../guards/auth.guard';
import { TripHistoryComponent } from './trip-history.component';

const routes: Routes = [
  { path: '', component: TripHistoryComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TripHistoryRoutingModule { }
